/* globals $, globalScene, allTweens, controller */
import { TimelineMax, Strong } from 'gsap';
import 'gsap/ScrollToPlugin';

import ScrollMagic from 'helpers/importers/ScrollMagic';
import updateGlobalScenes from 'helpers/scenes/updateGlobalScenes';

export default function careersScene () {
  let tween = new TimelineMax()
    .from($('#careers > .wrapper h2'), 0.5, {
      xPercent: -120,
      opacity: 0,
      ease: Strong.easeOut,
    })
    .from($('#careers > .wrapper > div > div'), 0.5, {
      xPercent: 120,
      opacity: 0,
      ease: Strong.easeOut,
    }, '=-0.5')
    .from($('#current-vacancies > .wrapper h2'), 0.5, {
      xPercent: -120,
      opacity: 0,
      ease: Strong.easeOut,
    })
    .staggerFrom('#current-vacancies > .wrapper .view-content .row', 0.5, {
      opacity: 0,
      yPercent: 100,
    }, 0.3);

  allTweens.push(tween);

  let sceneStart = new ScrollMagic.Scene({
    triggerElement: '#careers',
    offset: 100,
    duration: 0,
    triggerHook: 'onEnter',
  });
  //.addIndicators({name: "careers"})

  let scene = new ScrollMagic.Scene({
    triggerElement: '#careers',
    offset: 200,
    duration: 0,
    triggerHook: 'onEnter',
  })
  .setTween(tween);

  sceneStart.enabled(true);
  scene.enabled(true);

  sceneStart.addTo(controller);
  scene.addTo(controller);

  globalScene.push(sceneStart);
  globalScene.push(scene);

  updateGlobalScenes();
}


// WEBPACK FOOTER //
// ./apps/www.relic.com/src/helpers/scenes/careersScene.js